import { defineComponent as _defineComponent } from 'vue'
import { reactive, ref } from 'vue';
import NModel from '@/component/NModel/NModel.vue';
import moment from 'moment';
import { useForm } from '@/util/useForm';


export default /*#__PURE__*/_defineComponent({
  __name: 'CustomerServiceManage',
  setup(__props) {

const form = useForm();
const formValue = ref<any>();
const addVisible = ref<boolean>(false); // 新建客服
const editVisible = ref<boolean>(false); // 编辑客服
const editNickname = ref<string>(); // 编辑昵称
const labelCol = reactive({
  xs: { span: 24 },
  sm: { span: 7 },
});
const wrapperCol = reactive({
  xs: { span: 20 },
  sm: { span: 12 },
});
const pagination = ref<any>({
  current: 1,
  limit: 10,
  total: 1,
  showSizeChanger: true,
  showTotal: total => '共' + total + '条',
});
const dataSource = [
  {
    id: 1,
    nickname: '老王',
    name: '王硕',
    phone: '13665439520',
    create_time: 1684982269,
    state: 1,
  },
  {
    id: 2,
    nickname: '老田',
    name: '田宇',
    phone: '13684211168',
    create_time: 1684982269,
    state: 2,
  },
  {
    id: 3,
    nickname: '老张',
    name: '张宇晗',
    phone: '13666139761',
    create_time: 1684982269,
    state: 1,
  },
];

// 添加客服
function addCustomerService() {
  console.log('添加客服');
  addVisible.value = true;
}
// 添加客服-确定
function onAddCustomerService() {
  form.value.validateFields((err, val) => {
    if (!err) {
      formValue.value = {
        nickname: val.nickname,
        id: val.id,
        state: val.state,
      };
    }
    console.log(formValue.value);
    addVisible.value = false;
  });
}
// 编辑
function onEdit(record) {
  console.log('编辑', record);
  editNickname.value = record.nickname;
  console.log(editNickname.value);

  editVisible.value = true;
}
// 编辑客服-确定
function onEditCustomerService() {
  console.log('1');
}
// 停用/启用
function onChangeState(checked) {
  console.log(checked);
}
// 日期格式
function Format(time) {
  return moment(time * 1000).format('YYYY/MM/DD HH:mm:ss');
}

return { __sfc: true,form, formValue, addVisible, editVisible, editNickname, labelCol, wrapperCol, pagination, dataSource, addCustomerService, onAddCustomerService, onEdit, onEditCustomerService, onChangeState, Format, NModel }
}

})